import React from 'react';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useGStore } from '../context/Context';
import LoadingPage from '../pages/sheard/LoadingPage';

const PrivateRoute = ({children}) => {
    const {state,dispatch} = useGStore()
    const {user} = state;
    const navigation = useNavigate();
    if(state.loading){
        return <LoadingPage></LoadingPage>
    }
    if(!user.loginAccess){
        toast.error("You you have need admin approval")
        navigation("/login")
        return;
    }
    if(!user.role){
        toast.error("You must have a role")
        navigation("/login")
        return;
    }
    return <div>
        {children}
    </div>
};

export default PrivateRoute;